import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step1 = ({
  sra,
  setSra,
  setStep,
  storedUser,
  fileNames,
  setFileNames,
}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.title)) {
      newErrors.title = "Title is required";
    }

    if (isEmpty(data.companyName)) {
      newErrors.companyName = "Company Name is required";
    }

    if (isEmpty(data.address)) {
      newErrors.address = "Address is required";
    }

    if (isEmpty(data.poc)) {
      newErrors.poc = "Point of Contact is required";
    }

    if (isEmpty(data.structure)) {
      newErrors.structure = "Business Structure is required";
    }

    if (isEmpty(data.msme)) {
      newErrors.msme = "MSME Status is required";
    }

    if (isEmpty(data.need)) {
      newErrors.need = "Required Need is mandatory";
    }

    if (isEmpty(data.currentStatus)) {
      newErrors.currentStatus = "Current Status is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>New Vendor Approval Form</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "20%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Details</Typography>

        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="title">
              Title <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              name="title"
              id="title"
              onChange={handleChange}
              value={sra?.title || ""}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="vendorCode">Vendor Code</label>
            <input
              className={`${errors.vendorCode && "input-error"}`}
              type="text"
              name="vendorCode"
              id="vendorCode"
              onChange={handleChange}
              value={sra?.vendorCode || ""}
            />
            {errors.vendorCode && <p className="error">{errors.vendorCode}</p>}
          </Grid2>
          {/* Company Name */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="companyName">
              Company Name <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.companyName && "input-error"}`}
              type="text"
              name="companyName"
              id="companyName"
              onChange={handleChange}
              value={sra?.companyName || ""}
            />
            {errors.companyName && (
              <p className="error">{errors.companyName}</p>
            )}
          </Grid2>

          {/* Address */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="address">
              Address <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.address && "input-error"}`}
              type="text"
              name="address"
              id="address"
              onChange={handleChange}
              value={sra?.address || ""}
            />
            {errors.address && <p className="error">{errors.address}</p>}
          </Grid2>

          {/* POC */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="poc">
              Point of Contact <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.poc && "input-error"}`}
              type="text"
              name="poc"
              id="poc"
              onChange={handleChange}
              value={sra?.poc || ""}
            />
            {errors.poc && <p className="error">{errors.poc}</p>}
          </Grid2>

          {/* Structure */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="structure">
              Legal Structure <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <select
              className={`${errors.structure && "input-error"}`}
              name="structure"
              id="structure"
              onChange={handleChange}
              value={sra?.structure || ""}
            >
              <option value="">Select</option>
              <option value="Private Limited">Private Limited</option>
              <option value="Public Limited">Public Limited</option>
              <option value="AOP">AOP</option>
              <option value="LLP">LLP</option>
              <option value="HUF">HUF</option>
              <option value="Proprietorship">Proprietorship</option>
              <option value="Partnership">Partnership</option>
            </select>
            {errors.structure && <p className="error">{errors.structure}</p>}
          </Grid2>

          {/* MSME */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="msme">
              MSME <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.msme && "input-error"}`}
              type="text"
              name="msme"
              id="msme"
              onChange={handleChange}
              value={sra?.msme || ""}
            />
            {errors.msme && <p className="error">{errors.msme}</p>}
          </Grid2>

          {/* Need */}
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="need">
              Need For New Vendor <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.need && "input-error"}`}
              name="need"
              id="need"
              onChange={handleChange}
              value={sra?.need || ""}
              rows={2}
            />
            {errors.need && <p className="error">{errors.need}</p>}
          </Grid2>

          {/* Current Status */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="currentStatus">
              Current Status <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.currentStatus && "input-error"}`}
              type="text"
              name="currentStatus"
              id="currentStatus"
              onChange={handleChange}
              value={sra?.currentStatus || ""}
            />
            {errors.currentStatus && (
              <p className="error">{errors.currentStatus}</p>
            )}
          </Grid2>
        </Grid2>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleUpdate}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step1;
